module.exports = __webpack_public_path__ + "img/trophy-1.a3915c6c.svg";